(ns ui.components.text.view
  (:require [ui.util :as uu]))

(defn label
  [props & children]
  (into [:label
         {:class (uu/cm "font-semibold text-base-light-text" (:class props))}]
        (if (map? props) children (cons props children))))


(defn field-value
  [children]
  (into [:div
         {:class "text-base-light-text min-h-6"}]
        children))

(defn h1
  [{:keys [class]} & children]
  (into [:h1
         {:class (uu/cm "text-n-md font-n-bold flex items-center gap-3" class)}]
        children))

(defn h2-custom
  [{:keys [class]} & children]
  (into [:h2
         {:class (uu/cm "text-md font-bold flex items-center gap-2 text-base-light-text" class)}]
        children))

(defn h2
  [& children]
  (apply h2-custom (concat [{}] children)))

(defn h3
  [{:keys [_class]} & children]
  (into [:h3
         {:class (uu/cm "text-n-xs font-n-semi flex items-center gap-2")}]
        children))

(defn info-text
  [children]
  (into [:span
         {:class "text-sm text-base-light-text-paler mb-0"}]
        children))

(defn info-text-xs
  [{:keys [class]} & children]
  (into [:span
         {:class (uu/cm "text-xs text-base-light-text-paler mb-0"
                        class)}]
        children))

(defn p
  [children]
  (into [:p
         {:class "text-base-light-text"}]
        children))
